import React, { createContext, Dispatch, ReactElement, useReducer } from 'react'

type Props = {
    children: ReactElement
}

export const ForestsNearUsContext = createContext({} as IForestsNearUsContext);

type ContextAction =
    | { type: 'setTotalForestAreaSize', size: number }
    | { type: 'setNearForestAreaSize', size: number, count: number }
    | { type: "saveArea", id: string, communityId?: string }
    | { type: "getArea", id: string }
    | { type: "setDesiredAreaSize", size: number }
    | { type: "setDesiredAreaSizeMeters", size: number }
    | { type: "setIsAreaLoading", isLoading: boolean }
    | { type: "setAreaLoadError", isInError: boolean }
    | { type: "reset" };

function contextReducer(state: IForestsNearUsState, action: ContextAction): IForestsNearUsState {
    switch (action.type) {
        case 'setTotalForestAreaSize':
            return { ...state, totalForestAreaSize: action.size };
        case 'setNearForestAreaSize':
            return { ...state, nearForestAreaSize: action.size, nearForestCount: action.count };
        case 'getArea':
            return { ...state, selectedAreaToGetId: action.id };
        case 'saveArea':
            return { ...state, selectedAreaToSaveId: action.id, communityId: action.communityId };
        case "setDesiredAreaSize":
            return { ...state, desiredAreaSize: action.size };
        case "setDesiredAreaSizeMeters":
            return { ...state, desiredAreaSizeMeters: action.size };
        case "setIsAreaLoading":
            return { ...state, isAreaLoading: action.isLoading };
        case 'setAreaLoadError':
            return { ...state, isAreaLoadInError: action.isInError };
        case 'reset':
            return { ...initialState }
        default:
            throw new Error();
    }
}

export interface IForestsNearUsContext {
    forestsNearUsStateDispatch: Dispatch<ContextAction>,
    forestsNearUsState: IForestsNearUsState
}

export interface IAreaForDropDown {
    id: string,
    namefin: string
}

export interface IForestsNearUsState {
    totalForestAreaSize: number,
    nearForestAreaSize: number,
    nearForestCount: number,
    selectedAreaToSaveId: string,
    selectedAreaToGetId: string,
    communityId?: string,
    desiredAreaSize?: number,
    desiredAreaSizeMeters?: number,
    areasForDropDown: IAreaForDropDown[],
    isAreaLoading: boolean,
    isAreaLoadInError: boolean
}

const initialAreasForDropDown = [
    {
        id: "helsinki",
        namefin: "Helsinki"
    },
    {
        id: "vantaa",
        namefin: "Vantaa"
    },
    {
        id: "kerava",
        namefin: "Kerava"
    },
    {
        id: "tuusula",
        namefin: "Tuusula"
    },
    {
        id: "jarvenpaa",
        namefin: "Järvenpää"
    },
    {
        id: "hyvinkaa",
        namefin: "Hyvinkää"
    },
    {
        id: "nurmijarvi",
        namefin: "Nurmijärvi"
    },
    {
        id: "riihimaki",
        namefin: "Riihimäki"
    },
    {
        id: "turku",
        namefin: "Turku"
    },
    {
        id: "tampere",
        namefin: "Tampere"
    },
    {
        id: "jyvaskyla",
        namefin: "Jyväskylä"
    },
    {
        id: "oulu",
        namefin: "Oulu"
    }
];

const initialState = { ...{} as IForestsNearUsState, areasForDropDown: initialAreasForDropDown } as IForestsNearUsState;

export default function ForestsNearUsContextContainer(props: Props) {
    const [forestsNearUsState, forestsNearUsStateDispatch] = useReducer(contextReducer, initialState);

    return (
        <ForestsNearUsContext.Provider value={{ forestsNearUsStateDispatch, forestsNearUsState }}>
            {props.children}
        </ForestsNearUsContext.Provider>
    )
}